import * as yup from 'yup';
import { isIkeaEmail } from '@pcmp-checka/lib-utilities/string';

export type CreateInvitationFormData = {
  email: string;
  name: string;
};

export const createInvitationSchema = yup.object().shape({
  email: yup
    .string()
    .email('error.form.invalidEmail')
    .test('not-ikea-email', 'error.form.nonIngkaEmail', (value) =>
      value ? !isIkeaEmail(value) : true
    )
    .required('error.form.required'),
  name: yup.string().required('error.form.required'),
});
